module.exports = __webpack_public_path__ + "img/default_photo.2b0571b1.png";